// removed by extract-text-webpack-plugin
module.exports = {"zhThemeColor":"#dd231f","enThemeColor":"#0e5fac"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = syC2
// module chunks = 18